import { useCallback, useContext, useEffect, useState } from "react"
import { CreateContext } from "../../contexts/CreateContext";
import { UploadItem, UploadManager, UploadProgress } from "../UploadDropzone/uploadManager";
import { ChooseStep } from "./Steps/ChooseStep";
import { CompleteStep } from "./Steps/CompleteStep";
import { GalleryStep } from "./Steps/GalleryStep";
import { InfoStep } from "./Steps/InfoStep";


export const CreateStepper = () => {
    const { reset, step } = useContext(CreateContext);

    useEffect(() => {
        return () => {
            if (step === 'complete') {
                reset();
            }
        }
    }, [])

    return (
        <div className="text-2xl font-semibold">
            {step === 'choose' && <ChooseStep />}
            {step === 'info' && <InfoStep />}
            {step === 'gallery' && <GalleryStep />}
            {step === 'complete' && <CompleteStep />}
        </div>

    )
}